import { ConditionalFieldDefinition } from "~/models/conditionalRules/conditionalFieldDefinition";
import ProcessFlowStepJumpToFactory from '~/models/processFlows/processFlowStepJumpToFactory'
import {FormElementConditionalField} from '../../../formability/form_builder/models/conditionalRules/formElementConditionalFields'

// tslint:disable-next-line:no-empty-interface
export interface ProcessFlowVariableConditionalField extends ConditionalFieldDefinition {
}

export default class ProcessFlowStepElementConditionalFields {
  static JUMP_TO: ProcessFlowVariableConditionalField = {
    fieldName: 'jump_to',
    defaultConditionalValue: (parent, json) => ProcessFlowStepJumpToFactory.findOrCreate(parent, json),
    friendlyName: (r) => r.conditional_value
  };

  static SEARCH_CRITERIA: ProcessFlowVariableConditionalField = {
    fieldName: 'search_criteria',
    defaultConditionalValue: null,
    friendlyName: (r) => r.conditional_value
  }

  static PROCESS_FLOW_STEP_FIELDS: ProcessFlowVariableConditionalField[] = [
    ProcessFlowStepElementConditionalFields.JUMP_TO,
  ];

  static PROCESS_FLOW_STEP_ACTION_FIELDS: ProcessFlowVariableConditionalField[] = [
    ProcessFlowStepElementConditionalFields.JUMP_TO,
  ];

  static FIND_DATA_STEP_FIELDS: ProcessFlowVariableConditionalField[] = [
    ProcessFlowStepElementConditionalFields.SEARCH_CRITERIA,
  ];

  static FIND_COUNT_STEP_FIELDS: ProcessFlowVariableConditionalField[] = [
    ProcessFlowStepElementConditionalFields.SEARCH_CRITERIA,
  ];
}
